<mat-spinner [diameter]="diameter"></mat-spinner>
<span class="label"><ng-content></ng-content></span>
